import React from 'react';
import '../src/global.css';
// import '../src/style.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './Components/Header';
import Login from './Pages/LoginForm';
import ForgotPassword from './Pages/ForgotPassword';
import ResetPassword from './Pages/ResetPassword';
import AdminDashboard from './Pages/AdminDashboard';
import Users from './Pages/Users';
import Documents from './Pages/Documents';
// import RolePermissions from './Pages/Role&Pemissions';
import Department from './Pages/Departments';
import ViewDocuments from './Pages/ViewDocuments';
import BackgroundVerification from './Pages/BackGroundVerification';
import Policies from './Pages/Policies';
import DocumentUploadWithToken from './Pages/DocumentUploadWithToken';
import AddEmployee from './Pages/AddEmployee';
import UpdateEmployee from './Pages/UpdateEmployee';
import EmployeeDetails from './Pages/EmployeeDetails';

function App() {
  const location = useLocation();
  const noHeaderPaths = ['/', '/forgot-password', '/reset-password'];


  return (
    <>
      {/* {!noHeaderPaths.includes(location.pathname) && <Header />} */}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/users" element={<Users />} />
        <Route path="/documents" element={<Documents />} />
        {/* <Route path="/role-permissions" element={<RolePermissions />} /> */}
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/departments" element={<Department />} />
        <Route path="/view-documents" element={<ViewDocuments />} />
        <Route path="/bgv" element={<BackgroundVerification />} />
        <Route path="/policies" element={<Policies />} />
        <Route path="/document-upload" element={<DocumentUploadWithToken />} />
        <Route path="/add-employee" element={<AddEmployee />} />
        <Route path="/update-employee" element={<UpdateEmployee />} />
        <Route path="/employee-details" element={<EmployeeDetails />} />

      </Routes>
      </>
  );
}

export default function AppWrapper() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}